export const getCurrentLocale = state => state.translations.currentLocale

export const getAllPageModels = state => state.translations.pageModels

export const getCommonTranslations = state =>
  state.translations.commonTranslations

export const getOrderListingCommonTranslations = state =>
  state.translations.commonTranslations.portalOrderListingTranslationsBlock
